module.exports = __webpack_public_path__ + "static/media/importFlybook2.8a5d864d.png";